import { Component } from '@angular/core';
import { AccountingModelService } from './accountingModel.service';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { AccountingModel } from './accountingModel.model';
import { AccountingModelConst } from '../const';
import { CoreComponent } from '../../../core/header/core.component';
import { Router } from '@angular/router';
import { DummyComponent } from '../../../shared/dummy.component';
import { AccountingModelListComponent } from './accountingModel-list.component';

@Component({
    selector: 'convfact-accountingmodel-import',
    templateUrl: './accountingModel-import.component.html',
    styleUrls: ['./accountingModel.component.css'],
    standalone: false
})

export class AccountingModelImportComponent {

    constructor(
        private accountingModelServicea: AccountingModelService,
        public dialogRef: MatDialogRef<AccountingModelListComponent>,
        public snackBar: MatSnackBar,
        public dialog: MatDialog,
        private core: CoreComponent,
        private router: Router,
        public dummy: DummyComponent
    ) { }

    dataReady = false;
    working = false;
    dataSource: AccountingModel[] = [];
    headerTable: any[] = AccountingModelConst.headerTable;

    closeDialog() {
        this.dialogRef.close();
        this.dummy.redirectTo('account/accountingmodel');
    }

    downloadTemplate() {
        const win = window.open('https://drive.google.com/u/0/uc?id=1lCR4pzKtojjerCd3K8Sf2D-eZ-sCUWtB&export=download', '_blank');
        win.focus();
    }

    downloadDemoTemplate() {
        const win = window.open('https://drive.google.com/u/0/uc?id=1maBtwEetKaTBYc92a30juoxJTX-Ac9cW&export=download', '_blank');
        win.focus();
    }

    displayInfo(message: string): void {
        const options = new MatSnackBarConfig();
        options.duration = 10000;
        options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
    }

    addAccounts() {
        this.working = true;
        this.accountingModelServicea.importData(this.dataSource).then(response => {
            this.displayInfo(response);
            this.working = false;
        });
    }

    fileChange(event) {
        const fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            const file: File = fileList[0];
            const formData: FormData = new FormData();
            formData.append('file', file, file.name);
            this.accountingModelServicea.importContacts(formData).then(response => {
                this.dataSource = response;
                this.dataReady = true;
            });
        }
    }

}
